import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";

import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
//This has to be somewhere in the app for the extension methods to work
import "../src/extensions";

const route = document.getElementById("root");
const page = route?.getAttribute("data-page");

createRoot(document.getElementById("root")).render(
	<StrictMode>
		<App page={page} />
	</StrictMode>,
);
